<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="page-title">
      <i class="pi pi-user"> </i>
      <label class="name">会員検索</label>
    </div>

    <!-- ガード文言 -->
    <p>
      こちらでは、当プラットフォームの会員情報を探すことができます。<br>
      画面左側の検索条件を選択し、検索してください。<br>
      ※各会員のプロフィール等の記載情報について、当プラットフォーム及び運営事務局（内閣府）が管理・保証するものではありません。
    </p>

    <div class="search-flex">
      <!-- 検索条件入力 -->
      <div class="search-form-area">
        <form
          [formGroup]="a110SearchForm"
          (ngSubmit)="getMemberResultDataList(true)"
        >
          条件を指定して「<i class="pi pi-search"></i>」をクリック
          <div class="p-d-flex p-jc-between">
            <!-- 検索テキスト -->
            <div class="search-text">
              <input
                type="text"
                pInputText
                placeholder="フリーワード検索"
                (focus)="text_focus.toggle($event)"
                (blur)="text_focus.toggle($event)"
                formControlName="freeword"
              />
              <p-overlayPanel #text_focus>
                <ng-template pTemplate>
                  <div class="overlay-search-text">さらに絞り込む</div>
                </ng-template>
              </p-overlayPanel>
            </div>
            <!-- 検索ボタン -->
            <button
              pButton
              type="button"
              icon="pi pi-search"
              class="button1 search-button"
              (click)="getMemberResultDataList(true)"
            ></button>
          </div>

          <!-- 検索フォーム -->
          <div class="search-form">
            <p-accordion
              [multiple]="true"
              expandIcon="pi pi-plus"
              collapseIcon="pi pi-minus"
            >
              <!-- 表示 -->
              <p-accordionTab
                header="会員種別"
                [(selected)]="accordion_class_id"
              >
                <div class="form">
                  <div *ngFor="let dicData of getDicList(1)">
                    <p-checkbox
                      [label]="dicData.sp_name"
                      [value]="dicData.sp_code"
                      [formControl]="a110SearchForm.controls.class_id"
                    ></p-checkbox>
                  </div>
                </div>
              </p-accordionTab>
              <!-- 地域 -->
              <p-accordionTab
                header="地域"
                [(selected)]="accordion_prefectures"
              >
                <div *ngFor="let prefectures of prefecturesList">
                  <!-- 地域大項目 -->
                  <p-accordionTab
                    [(selected)]="
                      accordion_prefectures_detail[prefectures.code]
                    "
                  >
                    <ng-template pTemplate="header">
                      <p-checkbox
                        [label]="prefectures.name"
                        [value]="prefectures.code"
                        (onChange)="
                          checkLargePrefectures($event, prefectures.list)
                        "
                        [formControl]="a110SearchForm.controls.prefectures"
                      >
                      </p-checkbox>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <!-- 地域中項目 -->
                      <div class="form">
                        <div *ngFor="let list of prefectures.list">
                          <p-checkbox
                            [label]="list.sp_name"
                            [value]="list.sp_name"
                            (onChange)="
                              checkMediumPrefectures(
                                $event,
                                prefectures.code,
                                prefectures.list
                              )
                            "
                            [formControl]="a110SearchForm.controls.prefectures"
                          ></p-checkbox>
                        </div>
                      </div>
                    </ng-template>
                  </p-accordionTab>
                </div>
              </p-accordionTab>
              <!-- カテゴリ -->
              <p-accordionTab
                header="カテゴリ"
                [(selected)]="accordion_category"
              >
                <div *ngFor="let category of categoryList">
                  <!-- カテゴリ大項目 -->
                  <p-accordionTab
                    [(selected)]="accordion_category_detail[category.class_cd1]"
                  >
                    <ng-template pTemplate="header">
                      <p-checkbox
                        [label]="category.class_name1"
                        [value]="category.class_cd1"
                        (onChange)="checkLargeCategory($event, category.rec)"
                        [formControl]="a110SearchForm.controls.category"
                      >
                      </p-checkbox>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <!-- カテゴリ中項目 -->
                      <div class="form">
                        <div *ngFor="let list of category.rec">
                          <p-checkbox
                            [label]="list.class_name2"
                            [value]="list.value"
                            (onChange)="
                              checkMediumCategory(
                                $event,
                                category.class_cd1,
                                category.rec
                              )
                            "
                            [formControl]="a110SearchForm.controls.category"
                          ></p-checkbox>
                        </div>
                      </div>
                    </ng-template>
                  </p-accordionTab>
                </div>
              </p-accordionTab>
              <!-- 業種 -->
              <p-accordionTab
                header="業種"
                [(selected)]="accordion_industry_id"
              >
                <div class="form">
                  <div *ngFor="let dicData of getDicList(2)">
                    <p-checkbox
                      [label]="dicData.sp_name"
                      [value]="dicData.sp_code"
                      [formControl]="a110SearchForm.controls.industry_id"
                    ></p-checkbox>
                  </div>
                </div>
              </p-accordionTab>
              <!-- 目指すSDGsゴール -->
              <p-accordionTab
                header="目指すSDGsゴール"
                [(selected)]="accordion_sdgs_goal"
              >
                <div class="form form-sdgs-goal">
                  <div
                    class="checkbox-sdgs-goal p-d-flex p-as-center"
                    *ngFor="let dicData of getDicList(3)"
                  >
                    <p-checkbox
                      [value]="dicData.sp_code"
                      [formControl]="a110SearchForm.controls.sdgs_goal"
                    >
                    </p-checkbox>
                    <div class="image-margin"></div>
                    <img [src]="dicData.sp_ext" alt="image" />
                  </div>
                </div>
              </p-accordionTab>
              <!-- 未来都市 -->
              <div class="p-p-2 accordion-no-big-item p-text-bold">
                <div class="form">
                  <p-checkbox
                    [value]="'1'"
                    label='未来都市'
                    [formControl]="a110SearchForm.controls.future_city"
                  >
                  </p-checkbox>
                </div>
              </div>
            </p-accordion>
          </div>
          <!-- 検索ボタン -->
          <div class="p-d-flex p-jc-center">
            <button
              pButton
              type="button"
              label="検索"
              class="button1 new-button"
              (click)="getMemberResultDataList(true)"
            ></button>
          </div>
          <!-- クリアボタン -->
          <p-button
            label="検索条件をクリアする"
            styleClass="p-button-link"
            (click)="a110SearchForm.reset()"
          ></p-button>
        </form>
      </div>

      <!-- 結果表示 -->
      <div class="result-area">
        <!-- ページアンカー -->
        <a id="jump-top"></a>
        <!-- 検索結果数 -->
        <div class="result-count-area p-d-flex p-jc-between">
          <div>
            検索結果
            <label class="count"> {{ memberResultDataList.length }} </label>
            会員（総会員数：{{ countMemberData }}会員）
          </div>
          <!-- 課題・ソリューションツールチップ -->
          <div class="info-tooltip-area">
            <div class="icon">
              <img
                src="../../../../assets/images/logo2.png"
                alt="future-city-badge-icon"
              />
            </div>
            <div class="tooltip-text p-text-normal">
              <input id="swich1" class="swich_setting" type="checkbox">
              <label class="tooltip-text" for="swich1">
                SDGs未来都市とは？
                <span class="pre-line info-description" id="a101InfoText">
                  SDGs未来都市とは、地方創生SDGsの達成に向け、優れたSDGsの取組を提案する、内閣府が選定した地方自治体です。
画面左の条件検索から、全国のSDGs未来都市をお探しいただけます。
また、各SDGs未来都市の取り組みや詳細については、<a target="_blank" href="https://www.chisou.go.jp/tiiki/kankyo/miraitoshi.html">こちら（内閣府提供サイト）</a>からご覧いただけます。
                </span>
              </label>
            </div>
          </div>

        </div>
        <!-- リスト表示 -->
        <p-table
          #table
          [value]="memberResultDataList"
          [paginator]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first}~{last}会員を表示中(全{totalRecords}会員)"
          [rowsPerPageOptions]="[10, 50, 100, 500, 1000]"
          emptyMessage="データが存在しません"
          selectionMode="single"
          styleClass="list-area"
          (onPage)="jumpTop()"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="organization_name">会員名</th>
              <th class="prefectures">地域</th>
              <th class="category">取組内容</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-memberResultData>
            <tr
              class="list"
              (click)="
                viewDetailAgenda(
                  memberResultData.member_id,
                  memberResultData.class_id,
                  memberResultData.organization_name
                )
              "
            >
              <td class="organization_name">
                <div class="wraper">
                  <div class="text">
                    {{ memberResultData.organization_name }}
                  </div>
                  <div class="icon">
                    <img
                      *ngIf="memberResultData?.flag_future_city =='1'"
                      src="../../../../assets/images/logo2.png"
                      alt="future-city-badge-icon"
                      height="28px"
                    />
                  </div>
                </div>
              </td>
              <td class="prefectures">
                {{ memberResultData.prefectures }}
              </td>
              <td class="category">
                {{ memberResultData.activities_now }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
<app-member-detail-dialog></app-member-detail-dialog>
